import {
  FrameHighlightManager,
  FrameTool,
  PresentTool,
} from '@blocksuite/hive-block-frame';
import { ConnectionOverlay } from '@blocksuite/hive-block-surface';
import {
  BrushTool,
  EraserTool,
  HighlighterTool,
} from '@blocksuite/hive-gfx-brush';
import {
  ConnectorFilter,
  ConnectorTool,
} from '@blocksuite/hive-gfx-connector';
import {
  MindMapDragExtension,
  MindMapIndicatorOverlay,
} from '@blocksuite/hive-gfx-mindmap';
import { NoteTool } from '@blocksuite/hive-gfx-note';
import { ShapeTool } from '@blocksuite/hive-gfx-shape';
import { TemplateTool } from '@blocksuite/hive-gfx-template';
import { TextTool } from '@blocksuite/hive-gfx-text';
import { ElementTransformManager } from '@blocksuite/std/gfx';
import type { ExtensionType } from '@blocksuite/store';

import { EdgelessElementToolbarExtension } from './configs/toolbar';
import { EdgelessRootBlockSpec } from './edgeless-root-spec.js';
import { DblClickAddEdgelessText } from './element-transform/dblclick-add-edgeless-text.js';
import { SnapExtension } from './element-transform/snap-manager.js';
import { DefaultTool } from './gfx-tool/default-tool.js';
import { EmptyTool } from './gfx-tool/empty-tool.js';
import { PanTool } from './gfx-tool/pan-tool.js';
import { EditPropsMiddlewareBuilder } from './middlewares/base.js';
import { SnapOverlay } from './utils/snap-manager.js';

export const EdgelessToolExtension: ExtensionType[] = [
  DefaultTool,
  PanTool,
  EraserTool,
  TextTool,
  ShapeTool,
  NoteTool,
  BrushTool,
  ConnectorTool,
  TemplateTool,
  EmptyTool,
  FrameTool,
  PresentTool,
  HighlighterTool,
];

export const EdgelessEditExtensions: ExtensionType[] = [
  ElementTransformManager,
  ConnectorFilter,
  SnapExtension,
  MindMapDragExtension,
  FrameHighlightManager,
  DblClickAddEdgelessText,
];

export const EdgelessBuiltInManager: ExtensionType[] = [
  ConnectionOverlay,
  MindMapIndicatorOverlay,
  SnapOverlay,
  EditPropsMiddlewareBuilder,
  EdgelessElementToolbarExtension,
].flat();

export const EdgelessBuiltInSpecs: ExtensionType[] = [
  EdgelessRootBlockSpec,
  EdgelessToolExtension,
  EdgelessBuiltInManager,
  EdgelessEditExtensions,
].flat();
